import React from 'react'

const ErrorPage = () => {
  return (
    <div className=' flex flex-row items-center justify-center mx-auto text-4xl text-richblack-5 mt-28'>
        Oops Page Not found !
    </div>
  )
}

export default ErrorPage